module.exports = __webpack_public_path__ + "media/packs/images/flags/CU-7e9964f54832bbe9a8138a41d6982bc2.svg";